import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import * as Api from "../api/zones";

const useShared = () => {
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);

  const { isLoading: CityLoading, mutate: getCity } = useMutation(
    Api.getCities,
    {
      onSuccess: (data) => {
        // console.log(data.items);

        setCities(data.items);
      },
    }
  );


  const { isLoading: StateLoading, mutate: getState } = useMutation(
    Api.getStates,
    {
      onSuccess: (data) => {
        // console.log(data.items);

        setStates(data.items);
      },
    }
  );

  return { CityLoading, StateLoading, getCity, getState, cities, states };
};

export default useShared;
